import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL_WAREHOUSE;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit = (type) => {
    return ({
        type: type
    })
}

export const postProject = (state, setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        console.log(state)
        const body = {
            name: state?.name,
            description: state?.description,
            status: state?.status,
            director_name: state?.director_name,
            productioner_name: state?.productioner_name
        }
        axios.post(`${END_POINT}/api/company-projects`, body, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_PROJECT));
                dispatch(loadProjects());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}
export const loadProjects = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/company-projects`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_PROJECTS));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

export const deleteProject = (id, setloadDel, setIsDeleted, setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/company-projects/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_PROJECT));
                notifysuccess(res.data.message)
                setIsDeleted('deleted')
                setIdDeleted(id)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putProject = (id, name, description, director_name, productioner_name, status, setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        axios.put(`${END_POINT}/api/company-projects/${id}`,
            { name, description, director_name, productioner_name, status }
            , {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                if (res.data.status === "Success") {
                    dispatch(edit(types.EDIT_PROJECT));
                    dispatch(loadProjects());
                    notifysuccess(res.data.message)
                    setLoad(false)
                }
            }).catch((err) => {
                setLoad(false)
                notifyError(err.response.data.message)
            })
    }
}


export const filterProject = (name, email, role, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        setLoad(true);
        const queryParams = [];
        if (name !== '') queryParams.push(`filters[name]=${name}`);
        if (email !== '') queryParams.push(`filters[email]=${email}`);
        if (role !== '') queryParams.push(`filters[role]=${role}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/users?${finalQuery}`;
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((res) => {
            setLoad(false);
            dispatch(get(res.data.data, types.GET_PROJECTS));
        }).catch((err) => {
            ;
            setLoad(false);
        });
    };
};


